module.exports = __webpack_public_path__ + "assets/img/27_1169.f36300e3.jpg";